import React, {Component} from "react"
import propTypes from "prop-types"
import {isEmpty, isNil} from "lodash"
import {api} from "services/api"
import {AsyncSelectField} from "components/selectField"
import {canAddMaterial} from "helpers/parts"

class PartSelectField extends Component {
  constructor(props) {
    super(props)
    this.loadedOptions = []
  }

  processResult = (result) => {
    const {user, allowedTypes} = this.props
    let options = []

    if (!isEmpty(result)) {
      options = options.concat(
        result
          .filter(part => canAddMaterial(part.type, part.status, user, allowedTypes))
          .map(part => {
            return {
              type: part.type,
              id: part.id,
              value: 'OR' + part.id,
              label: part.partCode + ": " + part.description,
              part: part,
            }
          })
      )
    }

    options.forEach(option => {
      if (!this.loadedOptions.find(o => o.value === option.value)) {
        this.loadedOptions.push(option)
      }
    })

    return options
  }

  getOptionFromValue = (value) => {
    if (isNil(value)) return null

    if (value && typeof value === 'object' && value.value) {
      return value
    }

    const found = this.loadedOptions.find(opt => opt.value === value)
    return found || null
  }

  focus = () => {
    if (this.select && this.select.focus) {
      this.select.focus()
    }
  }

  render() {
    const {params, value, ...otherProps} = this.props
    const fields = {default: true, packs: true}

    const optionValue = this.getOptionFromValue(value)

    return (
      <AsyncSelectField
        ref={(c) => {
          this.select = c
        }}
        className='partSelectField'
        params={params}
        fields={fields}
        value={optionValue}
        onLoad={api.parts.get}
        onOptions={this.processResult}
        limit={50}
        {...otherProps}
      />
    )
  }
}

PartSelectField.propTypes = {
  clearable: propTypes.bool,
  disabled: propTypes.bool,
  isOptionDisabled: propTypes.func,
  onChange: propTypes.func,
  OptionRenderer: propTypes.func,
  params: propTypes.object,
  placeholder: propTypes.string,
  user: propTypes.object,
  value: propTypes.oneOfType([
    propTypes.string,
    propTypes.number,
    propTypes.shape({
      value: propTypes.any,
      label: propTypes.string,
    }),
  ]),
  allowedTypes: propTypes.arrayOf(propTypes.number),
  ValueRenderer: propTypes.func,
}

PartSelectField.defaultProps = {
  params: {},
}

export default PartSelectField
